// extracted by mini-css-extract-plugin
export default {"container":"ChildrenPage_container__nwiUO","actionsStrip":"ChildrenPage_actionsStrip__rer+n","childrenBody":"ChildrenPage_childrenBody__qg0B3"};